import {
  SearchScopeSchema,
  type SearchScope as GeneratedSearchScope
} from '~/services/api/generated'

export type SearchScope = GeneratedSearchScope

export const SearchScope = {
  CATEGORIES: SearchScopeSchema.enum.categories,
  ITEMS: SearchScopeSchema.enum.items
} satisfies Record<string, GeneratedSearchScope>

export const SearchScopeValues: readonly GeneratedSearchScope[] = [
  SearchScopeSchema.enum.categories,
  SearchScopeSchema.enum.items
]
